export const handleOpenPdf = (pdf) => {
  window.open(pdf);
};

export const convertDateFormat = (dateStr) => {
  const date = new Date(dateStr);
  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const CurrencyFormatter = (value) => {
  const formattedValue = value?.toLocaleString("en-US");

  return formattedValue;
};

export const formatTitleWithItalic = (title) => {
  const parts = title.split("-i");
  if (parts.length === 2) {
    return (
      <>
        {parts[0]}-<i>i</i>
        {parts[1]}
      </>
    );
  }
  return title;
}
